@for (growlerConfig of growlerConfigs(); track growlerConfig.id) {
  <div
    [class]="growlerConfig.growlerClasses"
    class="growler--show should-stay-masked"
    role="alert"
    aria-live="polite"
    [attr.aria-label]="growlerConfig.ariaLabel"
    (mouseenter)="onHoverState(true)"
    (mouseleave)="onHoverState(false)"
    (focusin)="onFocusState(true)"
    (focusout)="onFocusState(false)"
  >
    <lt-alert
      [severity]="growlerConfig.severity"
      [icon]="growlerConfig.icon"
      [closeable]="growlerConfig.showCloseButton"
      [title]="growlerConfig.title"
      [message]="growlerConfig.message"
      [items]="growlerConfig.items"
      [submit]="growlerConfig.submit"
      [submitType]="'button'"
      [submitButtonStyle]="growlerConfig.submitButtonStyle"
      [submitButtonIcon]="growlerConfig.submitButtonIcon"
      [submitLabel]="growlerConfig.submitLabel"
      (close)="dismissAt(growlerConfig.id)"
      (submitClick)="growlerConfig.submitted && growlerConfig.submitted()"
    ></lt-alert>
  </div>
}
